<template>
   <div id="servicio_externo">
      <div v-if="loading" class="text-center">
         <div class="loadingio-spinner-ripple-6armq16mc04">
            <div class="ldio-2tzb8vdk7pu">
               <div></div>
               <div></div>
            </div>
         </div>
      </div>
      <div v-else>
         <h3 class="fw-bold text-primary">
            {{ servicio_externo.codigo }} - {{ servicio_externo.servicio }}
         </h3>
         <hr />
         <div class="row">
            <div class="col-12 col-md-3">
               <div class="card">
                  <div class="card-body">
                     <ul class="list-arrow">
                        <li>
                           <router-link
                              v-bind:to="
                                 '/servicio_externo/' + id_servicio + '/basica'
                              "
                              href="javascript:void(0)"
                              >Información básica</router-link
                           >
                        </li>
                        <li>
                           <router-link
                              v-bind:to="
                                 '/servicio_externo/' +
                                 id_servicio +
                                 '/cotizador'
                              "
                              href="javascript:void(0)"
                              >Cotizador</router-link
                           >
                        </li>
                     </ul>
                  </div>
               </div>
            </div>
            <div class="col-12 col-md-9">
               <div class="col-12">
                  <div class="card ms-2">
                     <div class="card-body">
                        <router-view
                           :session="session"
                           :servicio_externo="servicio_externo"
                           :permiso="permiso"
                        />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";

export default {
   name: "ServicioExterno",
   metaInfo: {
      title: "Servicio externo - Backoffice",
   },
   data() {
      return {
         loading: true,
         id_servicio: null,
         servicio_externo: [],
         destinos: [],
         permiso: false,
      };
   },
   props: {
      session: Object,
   },
   created: function () {
      this.id_servicio = this.$route.params.id_servicio;
      this.get_servicio_externo();
      this.permiso = this.session.usuario.usuario.permisos.GSERVICIOS;
   },
   methods: {
      get_servicio_externo: function () {
         const vm = this;
         const headers = {
            "Content-Type": "application/json",
            "x-api-key": vm.$api_key,
            Token: vm.session.usuario.token_session,
         };
         let config = {
            headers: headers,
         };
         axios
            .get(
               vm.$base_url + "servicios/servicio_externo/" + this.id_servicio,
               config,
               {
                  headers: headers,
               },
            )
            .then((response) => {
               if (response.data.status) {
                  vm.servicio_externo = response.data.data.servicio_externo;
               } else {
                  vm.$notify({
                     group: "foo",
                     type: "error",
                     title: "Servicio Externo",
                     text: response.data.message,
                  });
               }
               vm.loading = false;
            })
            .catch((error) => {
               vm.$notify({
                  group: "foo",
                  type: "error",
                  title: "Servicio Externo",
                  text: error,
               });
               vm.loading = false;
            });
      },
   },
};
</script>
